import type { TaskCatalogCategory } from "../../../shared/types";

export const TASK_CATEGORY_LABELS: Record<TaskCatalogCategory, string> = {
  intelligence: "Intelligence",
  content: "Content",
  review: "Review",
  system: "System",
  research: "Research",
};

/**
 * Normalizes the one URL-backed Actions filter contract used by page and shell.
 * The catalog only returns Actions an operator can run, so there is no
 * runnable/full view split; a legacy `view` param is ignored.
 */
export function parseTaskFilters(search: string): {
  category: TaskCatalogCategory | "all";
} {
  const params = new URLSearchParams(search);
  const requestedCategory = params.get("category");
  return {
    category: requestedCategory && Object.prototype.hasOwnProperty.call(TASK_CATEGORY_LABELS, requestedCategory)
      ? requestedCategory as TaskCatalogCategory
      : "all",
  };
}
